// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.btn::after {
  content: none !important;
  display: none !important;
}

.certificates-page {
  background: var(--background-gray, var(--light));
  box-sizing: border-box;
  flex: 1 1 auto;
  margin: 0 auto !important;
  max-width: 1920px !important;
  min-height: 0;
  overflow: auto;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;
  width: 96% !important;
}

.page-heading {
  align-items: center;
  background: #fff;
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--primary);
  border-radius: 7px;
  display: flex;
  justify-content: space-between;
  margin: 0 0 1.2rem !important;
  min-height: 58px !important;
  padding: 0.9rem clamp(1rem, 3vw, 2rem);
  position: relative;
  text-align: center;
}

.page-heading::before,
.page-heading::after {
  content: none !important;
  display: none !important;
}

.page-heading__title {
  flex: 1 1 auto;
}

.page-heading h1 {
  color: var(--dark);
  font-size: clamp(1.3rem, 2vw, 1.65rem);
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

.page-introduction {
  color: var(--secondary);
  font-size: 0.82rem;
  margin: 0.25rem 0 0;
}

.page-actions {
  align-items: center;
  display: flex;
  gap: 0.6rem;
  position: absolute;
  right: clamp(1rem, 3vw, 2rem);
}

.list-controls {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin: -0.55rem 0 0.85rem;
}

.sort-control {
  align-items: flex-start;
  color: var(--secondary);
  display: flex;
  flex-direction: column;
  font-size: 0.68rem;
  gap: 0.15rem;
}

.sort-control select {
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  color: var(--dark);
  font-size: 0.78rem;
  min-height: 30px;
  padding: 0.2rem 1.5rem 0.2rem 0.45rem;
}

.nextpage-action {
  align-items: center;
  display: inline-flex;
  gap: 0.35rem;
  justify-content: center;
}

.nextpage-action mat-icon {
  font-size: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  width: 1.1rem;
}

.page-actions .nextpage-action {
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
  color: #fff !important;
}

.page-actions .nextpage-action:hover,
.page-actions .nextpage-action:focus,
.page-actions .nextpage-action:focus-visible {
  background: #0069d9 !important;
  border-color: #0069d9 !important;
  color: #fff !important;
}

.nextpage-action mat-icon {
  color: inherit;
}

.year-group {
  margin: 0 0 1.2rem;
}

.year-group__heading {
  align-items: center;
  background: transparent !important;
  background-image: none !important;
  color: var(--dark) !important;
  display: flex;
  gap: 0.75rem;
  margin: 0 0 0.45rem;
  min-height: 0 !important;
  padding: 0 !important;
  text-align: left !important;
  width: auto !important;
}

.year-group__heading::before,
.year-group__heading::after {
  content: none !important;
  display: none !important;
}

.year-group__heading h2 {
  color: var(--primary);
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
}

.year-group__toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  gap: 0.2rem;
  padding: 0.15rem 0;
}

.year-group__toggle:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.year-group__toggle mat-icon {
  font-size: 1.15rem;
  height: 1.15rem;
  width: 1.15rem;
}

.year-group__heading span {
  color: var(--secondary);
  font-size: 0.76rem;
}

.table-shell {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow-x: auto;
}

table {
  background: #fff;
  border-collapse: collapse;
  margin: 0;
  min-width: 720px;
  table-layout: fixed;
  width: 100%;
}

th {
  background: #f8f9fa;
  border-bottom: 1px solid #ced4da;
  color: var(--dark);
  font-size: 0.76rem;
  font-weight: 700;
  padding: 0.75rem 0.85rem;
  text-align: left;
}

td {
  border-bottom: 1px solid #e9ecef;
  color: var(--dark);
  font-size: 0.84rem;
  padding: 0.72rem 0.85rem;
  vertical-align: middle;
}

tbody tr:last-child td {
  border-bottom: 0;
}

th:first-child, td:first-child {
  width: 145px;
}

th:nth-child(2), td:nth-child(2) {
  width: 220px;
}

th:nth-child(4), td:nth-child(4) {
  width: 230px;
}

th:last-child, td:last-child {
  width: 150px;
}

.certificate-row {
  cursor: pointer;
}

.certificate-row:hover {
  background: var(--light);
}

.certificate-row:focus-visible {
  outline: 3px solid var(--primary);
  outline-offset: -3px;
}

.description-cell {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-cell {
  overflow: hidden;
}

.attachment-cell__content {
  align-items: center;
  display: flex;
  gap: 0.35rem;
  min-width: 0;
}

.attachment-cell__content mat-icon {
  color: var(--primary);
  flex: 0 0 auto;
  font-size: 1.1rem;
  height: 1.1rem;
  width: 1.1rem;
}

.attachment-cell__content span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions-cell__buttons {
  align-items: center;
  display: flex;
  gap: 0.35rem;
}

.icon-action {
  align-items: center;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  min-width: 34px;
  padding: 0.25rem;
  width: 34px;
}

.icon-action mat-icon {
  font-size: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  width: 1.1rem;
}

.icon-action--primary {
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
}

.icon-action--primary:hover, .icon-action--primary:focus-visible {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

.icon-action--danger {
  background: #fff !important;
  border: 1px solid var(--danger) !important;
  color: var(--danger) !important;
}

.icon-action--danger:hover, .icon-action--danger:focus-visible {
  background: var(--danger) !important;
  border-color: var(--danger) !important;
  color: #fff !important;
}

.state {
  align-items: center;
  border-radius: 4px;
  display: flex;
  gap: 0.65rem;
  margin: 0.7rem 0;
  padding: 0.7rem 0.9rem;
}

.state--error {
  background: color-mix(in srgb, var(--danger) 9%, white);
  border: 1px solid color-mix(in srgb, var(--danger) 35%, white);
  color: var(--danger);
}

.state--error span {
  flex: 1 1 auto;
}

.empty-state {
  align-items: center;
  background: #fff;
  border: 1px solid #dee2e6;
  color: var(--secondary);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  margin-top: 0.9rem;
  padding: 2rem;
  text-align: center;
}

.empty-state > mat-icon {
  color: var(--primary);
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
}

.empty-state p {
  margin: 0;
}

@media (max-width: 700px) {
  .certificates-page {
    width: 100% !important;
  }
  .page-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.8rem;
    padding-bottom: 5.2rem;
  }
  .page-actions {
    bottom: 0.7rem;
    left: 1rem;
    right: auto;
  }
  .list-controls {
    justify-content: flex-start;
    margin: 0 0 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/yearly-calibration-certificates/yearly-calibration-certificates.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gDAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,oDAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,wBAAA;AACF;;AAEA;EAAuB,cAAA;AAEvB;;AADA;EAAmB,kBAAA;EAAoB,sCAAA;EAAwC,gBAAA;EAAkB,iBAAA;EAAmB,SAAA;AASpH;;AARA;EAAqB,uBAAA;EAAyB,kBAAA;EAAmB,mBAAA;AAcjE;;AAbA;EAAgB,mBAAA;EAAqB,aAAA;EAAe,WAAA;EAAY,kBAAA;EAAoB,6BAAA;AAqBpF;;AApBA;EAAiB,mBAAA;EAAqB,aAAA;EAAe,YAAA;EAAa,yBAAA;EAA2B,0BAAA;AA4B7F;;AA3BA;EAAgB,uBAAA;EAAyB,uBAAA;EAAyB,aAAA;EAAe,sBAAA;EAAwB,kBAAA;EAAmB,YAAA;AAoC5H;;AAnCA;EAAuB,gBAAA;EAAkB,yBAAA;EAA2B,kBAAA;EAAoB,kBAAA;EAAoB,kBAAA;EAAmB,gBAAA;EAAkB,qCAAA;AA6CjJ;;AA5CA;EAAmB,mBAAA;EAAqB,oBAAA;EAAsB,YAAA;EAAa,uBAAA;AAmD3E;;AAlDA;EAA4B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAyDpF;;AAxDA;EACE,qCAAA;EACA,2CAAA;EACA,sBAAA;AA2DF;;AAzDA;;;EAGE,8BAAA;EACA,gCAAA;EACA,sBAAA;AA4DF;;AA1DA;EAA4B,cAAA;AA8D5B;;AA5DA;EAAc,kBAAA;AAgEd;;AA/DA;EACE,mBAAA;EACA,kCAAA;EACA,iCAAA;EACA,6BAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;AAkEF;;AAhEA;;EAEE,wBAAA;EACA,wBAAA;AAmEF;;AAjEA;EAA0B,qBAAA;EAAuB,eAAA;EAAiB,gBAAA;EAAkB,SAAA;AAwEpF;;AAvEA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;EAAW,cAAA;EAAgB,eAAA;EAAiB,oBAAA;EAAsB,aAAA;EAAe,WAAA;EAAY,kBAAA;AAmFjK;;AAlFA;EAAoC,iCAAA;EAAmC,mBAAA;AAuFvE;;AAtFA;EAA+B,kBAAA;EAAoB,eAAA;EAAiB,cAAA;AA4FpE;;AA3FA;EAA4B,uBAAA;EAAyB,kBAAA;AAgGrD;;AA9FA;EAAe,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;AAoG9D;;AAnGA;EAAQ,gBAAA;EAAkB,yBAAA;EAA2B,SAAA;EAAW,gBAAA;EAAkB,mBAAA;EAAqB,WAAA;AA4GvG;;AA3GA;EAAK,mBAAA;EAAqB,gCAAA;EAAkC,kBAAA;EAAoB,kBAAA;EAAmB,gBAAA;EAAkB,wBAAA;EAAwB,gBAAA;AAqH7I;;AApHA;EAAK,gCAAA;EAAkC,kBAAA;EAAoB,kBAAA;EAAmB,wBAAA;EAAwB,sBAAA;AA4HtG;;AA3HA;EAAyB,gBAAA;AA+HzB;;AA9HA;EAAiC,YAAA;AAkIjC;;AAjIA;EAAmC,YAAA;AAqInC;;AApIA;EAAmC,YAAA;AAwInC;;AAvIA;EAA+B,YAAA;AA2I/B;;AA1IA;EAAmB,eAAA;AA8InB;;AA7IA;EAAyB,wBAAA;AAiJzB;;AAhJA;EAAiC,iCAAA;EAAmC,oBAAA;AAqJpE;;AApJA;EAAoB,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA2J7E;;AA1JA;EAAmB,gBAAA;AA8JnB;;AA7JA;EAA4B,mBAAA;EAAqB,aAAA;EAAe,YAAA;EAAa,YAAA;AAoK7E;;AAnKA;EAAqC,qBAAA;EAAuB,cAAA;EAAgB,iBAAA;EAAmB,cAAA;EAAgB,aAAA;AA2K/G;;AA1KA;EAAiC,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAgL5E;;AA/KA;EAAyB,mBAAA;EAAqB,aAAA;EAAe,YAAA;AAqL7D;;AApLA;EAAe,mBAAA;EAAqB,oBAAA;EAAsB,YAAA;EAAc,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;EAAiB,WAAA;AA8LnI;;AA7LA;EAAwB,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAoMhF;;AAnMA;EAAwB,2BAAA;EAA6B,2CAAA;EAA6C,gCAAA;AAyMlG;;AAxMA;EAAmE,qCAAA;EAAuC,uCAAA;EAAyC,sBAAA;AA8MnJ;;AA7MA;EAAuB,2BAAA;EAA6B,0CAAA;EAA4C,+BAAA;AAmNhG;;AAlNA;EAAiE,oCAAA;EAAsC,sCAAA;EAAwC,sBAAA;AAwN/I;;AAtNA;EAAS,mBAAA;EAAqB,kBAAA;EAAoB,aAAA;EAAe,YAAA;EAAa,gBAAA;EAAiB,sBAAA;AA+N/F;;AA9NA;EAAgB,uDAAA;EAAyD,8DAAA;EAAgE,oBAAA;AAoOzI;;AAnOA;EAAqB,cAAA;AAuOrB;;AAtOA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,yBAAA;EAA2B,uBAAA;EAAyB,aAAA;EAAe,sBAAA;EAAwB,WAAA;EAAY,kBAAA;EAAmB,aAAA;EAAe,kBAAA;AAmP/L;;AAlPA;EAA0B,qBAAA;EAAuB,eAAA;EAAiB,YAAA;EAAc,WAAA;AAyPhF;;AAxPA;EAAiB,SAAA;AA4PjB;;AA1PA;EACE;IAAqB,sBAAA;EA8PrB;EA7PA;IAAgB,uBAAA;IAAyB,sBAAA;IAAwB,WAAA;IAAY,sBAAA;EAmQ7E;EAlQA;IAAgB,cAAA;IAAe,UAAA;IAAY,WAAA;EAuQ3C;EAtQA;IAAiB,2BAAA;IAA6B,mBAAA;EA0Q9C;AACF","sourcesContent":[":host {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.certificates-page {\n  background: var(--background-gray, var(--light));\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  margin: 0 auto !important;\n  max-width: 1920px !important;\n  min-height: 0;\n  overflow: auto;\n  padding: .65rem clamp(.65rem, 2vw, 1.4rem) .75rem;\n  width: 96% !important;\n}\n\n.page-heading {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-left: 4px solid var(--primary);\n  border-radius: 7px;\n  display: flex;\n  justify-content: space-between;\n  margin: 0 0 1.2rem !important;\n  min-height: 58px !important;\n  padding: .9rem clamp(1rem, 3vw, 2rem);\n  position: relative;\n  text-align: center;\n}\n\n.page-heading::before,\n.page-heading::after {\n  content: none !important;\n  display: none !important;\n}\n\n.page-heading__title { flex: 1 1 auto; }\n.page-heading h1 { color: var(--dark); font-size: clamp(1.3rem, 2vw, 1.65rem); font-weight: 700; line-height: 1.15; margin: 0; }\n.page-introduction { color: var(--secondary); font-size: .82rem; margin: .25rem 0 0; }\n.page-actions { align-items: center; display: flex; gap: .6rem; position: absolute; right: clamp(1rem, 3vw, 2rem); }\n.list-controls { align-items: center; display: flex; gap: .75rem; justify-content: flex-end; margin: -.55rem 0 .85rem; }\n.sort-control { align-items: flex-start; color: var(--secondary); display: flex; flex-direction: column; font-size: .68rem; gap: .15rem; }\n.sort-control select { background: #fff; border: 1px solid #ced4da; border-radius: 4px; color: var(--dark); font-size: .78rem; min-height: 30px; padding: .2rem 1.5rem .2rem .45rem; }\n.nextpage-action { align-items: center; display: inline-flex; gap: .35rem; justify-content: center; }\n.nextpage-action mat-icon { font-size: 1.1rem; height: 1.1rem; line-height: 1.1rem; width: 1.1rem; }\n.page-actions .nextpage-action {\n  background: var(--primary) !important;\n  border: 1px solid var(--primary) !important;\n  color: #fff !important;\n}\n.page-actions .nextpage-action:hover,\n.page-actions .nextpage-action:focus,\n.page-actions .nextpage-action:focus-visible {\n  background: #0069d9 !important;\n  border-color: #0069d9 !important;\n  color: #fff !important;\n}\n.nextpage-action mat-icon { color: inherit; }\n\n.year-group { margin: 0 0 1.2rem; }\n.year-group__heading {\n  align-items: center;\n  background: transparent !important;\n  background-image: none !important;\n  color: var(--dark) !important;\n  display: flex;\n  gap: .75rem;\n  margin: 0 0 .45rem;\n  min-height: 0 !important;\n  padding: 0 !important;\n  text-align: left !important;\n  width: auto !important;\n}\n.year-group__heading::before,\n.year-group__heading::after {\n  content: none !important;\n  display: none !important;\n}\n.year-group__heading h2 { color: var(--primary); font-size: 1rem; font-weight: 700; margin: 0; }\n.year-group__toggle { align-items: center; background: transparent; border: 0; color: inherit; cursor: pointer; display: inline-flex; font: inherit; gap: .2rem; padding: .15rem 0; }\n.year-group__toggle:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }\n.year-group__toggle mat-icon { font-size: 1.15rem; height: 1.15rem; width: 1.15rem; }\n.year-group__heading span { color: var(--secondary); font-size: .76rem; }\n\n.table-shell { border: 1px solid #dee2e6; border-radius: 4px; overflow-x: auto; }\ntable { background: #fff; border-collapse: collapse; margin: 0; min-width: 720px; table-layout: fixed; width: 100%; }\nth { background: #f8f9fa; border-bottom: 1px solid #ced4da; color: var(--dark); font-size: .76rem; font-weight: 700; padding: .75rem .85rem; text-align: left; }\ntd { border-bottom: 1px solid #e9ecef; color: var(--dark); font-size: .84rem; padding: .72rem .85rem; vertical-align: middle; }\ntbody tr:last-child td { border-bottom: 0; }\nth:first-child, td:first-child { width: 145px; }\nth:nth-child(2), td:nth-child(2) { width: 220px; }\nth:nth-child(4), td:nth-child(4) { width: 230px; }\nth:last-child, td:last-child { width: 150px; }\n.certificate-row { cursor: pointer; }\n.certificate-row:hover { background: var(--light); }\n.certificate-row:focus-visible { outline: 3px solid var(--primary); outline-offset: -3px; }\n.description-cell { max-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.attachment-cell { overflow: hidden; }\n.attachment-cell__content { align-items: center; display: flex; gap: .35rem; min-width: 0; }\n.attachment-cell__content mat-icon { color: var(--primary); flex: 0 0 auto; font-size: 1.1rem; height: 1.1rem; width: 1.1rem; }\n.attachment-cell__content span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.actions-cell__buttons { align-items: center; display: flex; gap: .35rem; }\n.icon-action { align-items: center; display: inline-flex; height: 34px; justify-content: center; min-width: 34px; padding: .25rem; width: 34px; }\n.icon-action mat-icon { font-size: 1.1rem; height: 1.1rem; line-height: 1.1rem; width: 1.1rem; }\n.icon-action--primary { background: #fff !important; border: 1px solid var(--primary) !important; color: var(--primary) !important; }\n.icon-action--primary:hover, .icon-action--primary:focus-visible { background: var(--primary) !important; border-color: var(--primary) !important; color: #fff !important; }\n.icon-action--danger { background: #fff !important; border: 1px solid var(--danger) !important; color: var(--danger) !important; }\n.icon-action--danger:hover, .icon-action--danger:focus-visible { background: var(--danger) !important; border-color: var(--danger) !important; color: #fff !important; }\n\n.state { align-items: center; border-radius: 4px; display: flex; gap: .65rem; margin: .7rem 0; padding: .7rem .9rem; }\n.state--error { background: color-mix(in srgb, var(--danger) 9%, white); border: 1px solid color-mix(in srgb, var(--danger) 35%, white); color: var(--danger); }\n.state--error span { flex: 1 1 auto; }\n.empty-state { align-items: center; background: #fff; border: 1px solid #dee2e6; color: var(--secondary); display: flex; flex-direction: column; gap: .7rem; margin-top: .9rem; padding: 2rem; text-align: center; }\n.empty-state > mat-icon { color: var(--primary); font-size: 2rem; height: 2rem; width: 2rem; }\n.empty-state p { margin: 0; }\n\n@media (max-width: 700px) {\n  .certificates-page { width: 100% !important; }\n  .page-heading { align-items: flex-start; flex-direction: column; gap: .8rem; padding-bottom: 5.2rem; }\n  .page-actions { bottom: .7rem; left: 1rem; right: auto; }\n  .list-controls { justify-content: flex-start; margin: 0 0 .85rem; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
